/**
 * This variable allow us to do calculations on breakpoint values in styled components
 * avoiding the need to extract number from string because it has a unit like `px`.
 */
export const breakpointSizes = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

/**
 * Mobile-first breakpoints:
 * Devices smaller than 576px are applied by default without any media-queries.
 *
 * Borrowed from:
 * https://getbootstrap.com/docs/5.1/layout/breakpoints/
 */
export const breakpoints = {
  xs: `${breakpointSizes.xs}px`,
  sm: `${breakpointSizes.sm}px`,
  md: `${breakpointSizes.md}px`,
  lg: `${breakpointSizes.lg}px`,
  xl: `${breakpointSizes.xl}px`,
  xxl: `${breakpointSizes.xxl}px`,
};

export type BreakPoints = keyof typeof breakpoints;

/**
 * Query conditions - example usage:
 * when multiple conditions need to be applied to a single query.
 */
export const mediaQueryConditions = {
  /** Phone - portrait orientation (up to 576px) - implied by default, but added here for readability */
  xs: `max-width: ${breakpoints.sm}`,

  /** Phone - landscape orientation (576px and up). */
  sm: `min-width: ${breakpoints.sm}`,

  /** Tablets (768px and up)  .*/
  md: `min-width: ${breakpoints.md}`,

  /** Desktops (992px and up). */
  lg: `min-width: ${breakpoints.lg}`,

  /** Larger desktops (1200px and up). */
  xl: `min-width: ${breakpoints.xl}`,

  /** Larger desktops (1400px and up.) */
  xxl: `min-width:${breakpoints.xxl}`,
};

/**
 * Mobile first media queries.
 */
export const mediaQueries = {
  /** Phone - portrait orientation (up to 576px). */
  xs: `@media screen and (${mediaQueryConditions.xs})`,

  /** Phone - landscape orientation (576px and up). */
  sm: `@media screen and (${mediaQueryConditions.sm})`,

  /** Tablets (768px and up) .*/
  md: `@media screen and (${mediaQueryConditions.md})`,

  /** Desktops (992px and up). */
  lg: `@media screen and (${mediaQueryConditions.lg})`,

  /** Larger desktops (1200px and up). */
  xl: `@media screen and (${mediaQueryConditions.xl})`,

  /** Larger desktops (1400px and up.) */
  xxl: `@media screen and (${mediaQueryConditions.xxl})`,
};
